import FormField from "../form-field";
import FileInput from "../inputs/file-input";

export default class FileField extends FormField {
	constructor(props) {
		super(props);

		this.inputModule = null;

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('FileField: Root element is not defined!');
		}

		const $inputRoot = this.$root.querySelector('.file-input');

		this.inputModule = new FileInput({
			$root: $inputRoot
		});

		super.init();
	}

	addEventListeners() {
		this.inputModule.subscribe(this.VALUE_CHANGE_EVENT, ({ detail }) => {
			this.setValue(detail);
		});
	}

	setValue(value) {
		this.value = value;

		if (this.required) {
			this.validateSoft();
		}

		this.dispatchEvent(this.VALUE_CHANGE_EVENT, this.value);
	}

	validate() {
		this.isValid = this.value != null;
	}

	setInitialState() {
		this.inputModule.dropState();
	}

	getData() {
		const data = {}

		if (this.value != null) {
			Object.assign(data, { [this.name]: this.value });
		}

		return Object.keys(data).length ? data : null;
	}
}